const TabFormWrapper = ({ children, onSubmit }) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="px-4 py-6 sm:p-8">{children}</div>
    </form>
  );
};

export default TabFormWrapper;
